// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Ysly","dragIcon":"Choice_dragIcon__17LpU","left":"Choice_left__1_eHP","input":"Choice_input__1B5yd"};